module.exports = __webpack_public_path__ + "./fonts/icomoon.25dca0.woff";